// Measure an element (ResizeObserver). The first measurement happens in a layout effect, before paint.
import { useLayoutEffect, useState } from 'preact/hooks';
import type { RefObject } from 'preact';

export interface Size { w: number; h: number }

export function useSize(ref: RefObject<Element>, initial: Size = { w: 0, h: 0 }): Size {
  const [size, setSize] = useState<Size>(initial);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const read = () => {
      const r = el.getBoundingClientRect();
      const w = Math.round((el as HTMLElement).clientWidth || r.width);
      const h = Math.round((el as HTMLElement).clientHeight || r.height);
      setSize((s) => (s.w === w && s.h === h ? s : { w, h }));
    };
    read();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', read);
      return () => window.removeEventListener('resize', read);
    }
    const ro = new ResizeObserver(read);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref.current]);
  return size;
}
